import React, { useState } from "react";
import { FileIcon } from "./FileIcon";

export const NodeRendererNew = ({
  element,
  getNodeProps,
  level,
  onCancelNewFile,
  onConfirmNewFile
}) => {

  const [ value, setValue ] = useState("");

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleOnBlur = () => {
    onCancelNewFile && onCancelNewFile(element.id);
  };

  const handleOnChange = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setValue(event.target.value);
  };

  const handleOnKeyDown = (event) => {
    const key = event.keyCode || event.which;
    if (key === 13) {
      event.preventDefault();
      event.stopPropagation();
      onConfirmNewFile && onConfirmNewFile(element.id, value, element.metadata?.type);
      return false;
    }
    if (event.key === "Backspace" || event.key === "ArrowLeft" || event.key === "ArrowRight") {
      return true;
    }
    if ((key >= 65 && key <= 90) || (key >= 97 && key <= 122) || key === 95) {
      setValue(value => value + (event.shiftKey ? String.fromCharCode(key).toUpperCase() : String.fromCharCode(key).toLowerCase()));
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  return  (
    <div
      {...getNodeProps()}
      style={{
        paddingLeft: 10 * (level - 1),
        textWrap: "nowrap",
        display: "flex",
        alignItems: "center",
        gap: 6,
      }}
      onClick={handleOnClick}
      onMouseDown={handleOnClick}
    >
      <>
        <FileIcon
          type={element.metadata?.type}
          style={{ width: 18, minWidth: 18, height: 18, verticalAlign: "middle" }}
        />
      </>
      <input 
        onKeyDown={handleOnKeyDown}
        autoFocus={true} 
        onBlur={handleOnBlur} 
        type="text" 
        value={value} 
        onChange={handleOnChange} 
        onClick={handleOnClick}
        onMouseDown={handleOnClick}
        style={{
          flex: 1,
          minWidth: 0,
          maxWidth: 220,
          height: 24,
          padding: "2px 6px",
          borderRadius: 4,
          border: "1px solid #5f6158",
          backgroundColor: "#1f201d",
          color: "#f5f5f5",
          outline: "none",
        }}
      />
    </div>
  )  
}
